/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const CustomerCreateBody = zod.object({
  name: zod.string(),
});

export type CustomerCreateBody = zod.input<typeof CustomerCreateBody>;
export type CustomerCreateBodyOutput = zod.output<typeof CustomerCreateBody>;
